// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6715b901","977":"f88ecfe8"}[chunkId] + ".chunk.js";
};